import "./Goals.css";
import doctors from "../../assets/doctors.png";
import GoalCard from "./GoalCard";
import { PiHandshake } from "react-icons/pi";
import { TbHealthRecognition } from "react-icons/tb";
import { BiSolidTime } from "react-icons/bi";
import { ImCheckboxChecked } from "react-icons/im";
import { GoGoal } from "react-icons/go";
import { MdOutlineRemoveRedEye } from "react-icons/md";

const Goals = () => {
  return (
    <div className="goals-bg">
      <div className="goals-content">
        <h2>Our Goals and Vision Statement</h2>

        <div className="img-cover">
          <img src={doctors} alt="doctors" />
        </div>

        <div className="goal-vision-wrapper">
          <div className="card vision-card">
            <div className="card-icon">
              <GoGoal />
            </div>
            <h2>Goal Statement</h2>
            <p>
              To build a happy, empowered community of healthcare professionals,
              simplify healthcare freelancing, provide efficient professionals
              and payroll management system, and enabling uninterrupted
              healthcare delivery through a reliable pool of skilled
              professionals.{" "}
            </p>
          </div>

          <div className="card vision-card">
            <div className="card-icon">
              <MdOutlineRemoveRedEye />
            </div>
            <h2>Vision Statement</h2>
            <p>
              To become Africa’s most trusted healthcare freelancing platform;
              where professionals thrive, systems work seamlessly, and every
              healthcare provider and system can count on a dependable workforce
              anytime, anywhere.
            </p>
          </div>
        </div>

        <div className="grid-flex">
          <GoalCard
            icon={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: "white",
                  justifyContent: "center",
                }}
              >
                <ImCheckboxChecked style={{ fontSize: "1.5rem" }} />

                <h4>Quality & Reliability</h4>
              </div>
            }
            title="Streamlined hiring process ensuring the highest standards of healthcare professionals"
            bgColor="#F5A656"
          />
          <GoalCard
            icon={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: "white",
                  justifyContent: "center",
                }}
              >
                <TbHealthRecognition style={{ fontSize: "1.8rem" }} />

                <h4>Accessibility</h4>
              </div>
            }
            title="Access to a vast pool of healthcare professionals across Africa"
            bgColor="#20A4D3"
          />
          <GoalCard
            icon={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: "white",
                  justifyContent: "center",
                }}
              >
                <BiSolidTime style={{ fontSize: "1.8rem" }} />
                <h4>Flexibility</h4>
              </div>
            }
            title="Convenience and flexibility for both healthcare providers and professionals"
            bgColor="#62D8E0"
          />
          <GoalCard
            icon={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: "white",
                  justifyContent: "center",
                }}
              >
                <PiHandshake style={{ fontSize: "1.8rem" }} />
                <h4>Partnerships</h4>
              </div>
            }
            title="Building long-term partnerships with healthcare institutions"
            bgColor="#36A695"
          />
        </div>
      </div>
    </div>
  );
};

export default Goals;
